export enum  ArrangementFee{

    PRIMERA_CUOTA = 'PRIMERA_CUOTA',

    PAGO_TIENDA = 'PAGO_TIENDA',

    FINANCIADO = 'FINANCIADO',

    APLA0 = 'APLA0'
}